const appType = import.meta.env.VITE_APP_TYPE
export default {
  auth: `INN-${appType}-auth`,
  remember: `INN-${appType}-remember`,
}
